if (!customElements.get('home-load-more')) {
  customElements.define(
    'home-load-more',
    class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;

        this.button = this.querySelector('button');
        this.status = this.querySelector('[data-status]');

        if (!this.button || !this.status) return;

        this.ready = true;
        this.button.addEventListener('click', () => this.load());
      }

      findGrid(root, id) {
        const grid = root.querySelector('#' + CSS.escape(id));
        if (grid) return grid;

        for (const template of root.querySelectorAll('template')) {
          const match = this.findGrid(template.content, id);
          if (match) return match;
        }

        return null;
      }

      async load() {
        if (this.button.disabled) return;

        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.status.textContent = 'Loading…';

        try {
          const url = new URL(this.dataset.next, location.origin);
          url.searchParams.set('section_id', this.dataset.section);

          const response = await fetch(url.toString());

          if (!response.ok) {
            throw new Error('Request failed');
          }

          const html = await response.text();

          if (!this.isConnected) return;

          const parsed = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const current = document.getElementById(
            this.dataset.target
          );

          const incoming = this.findGrid(
            parsed,
            this.dataset.target
          );

          const currentList = current?.querySelector(
            '.featured-collection__items'
          );

          const incomingList = incoming?.querySelector(
            '.featured-collection__items'
          );

          if (!currentList || !incomingList) {
            throw new Error('Product grid not found');
          }

          const products = Array.from(incomingList.children).filter(
            (item) => item.hasAttribute('data-home-load-product')
          );

          if (!products.length) {
            throw new Error('No additional products returned');
          }

          const nextButton = incoming.nextElementSibling;

          const nextUrl = nextButton?.matches('home-load-more')
            ? nextButton.dataset.next
            : null;

          const fragment = document.createDocumentFragment();

          products.forEach((product) => {
            fragment.appendChild(
              document.importNode(product, true)
            );
          });

          currentList.appendChild(fragment);

          this.status.textContent =
            `${products.length} more products loaded.`;

          if (nextUrl) {
            this.dataset.next = nextUrl;
          } else {
            this.button.hidden = true;
          }
        } catch (error) {
          this.status.textContent =
            'Could not load products. Please try again.';

          console.error('Homepage load more:', error);
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
